import { Directive, Input, TemplateRef } from '@angular/core';
import type { PtlTableColumn } from './ptl-table.component';

/**
 * Marks an <ng-template ptlCell="columnKey"> whose content renders the cell for
 * that column in <ptl-data-table>. The template context exposes the row as both
 * `$implicit` and `row`, e.g. `<ng-template ptlCell="name" let-row>`.
 *
 * `column` carries the column being rendered — the handle a template shared by
 * several columns (via `PtlTableColumn.templateKey`) uses to find its own value
 * on the row, e.g. `<ng-template ptlCell="score" let-row let-column="column">`.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- design-system attribute API (ptlCell), not an app 'og' directive
  selector: 'ng-template[ptlCell]',
})
export class PtlTableCellDirective {
  @Input('ptlCell') column!: string;

  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  constructor(public readonly template: TemplateRef<{ $implicit: any; row: any; column: PtlTableColumn }>) {}
}
